<template>
  <div class="details-pane">
    <div class="details-pane-header row no-gutters">
      <div v-if="!hideTitle" class="details-pane-title col-9 py-3 pl-4">
        <slot name="title">
          <h2 class="m-0" data-toggle="tooltip" :title="title">
            {{ title | shorten(30) }}
          </h2>
        </slot>
      </div>
      <div v-if="!hideTitle" class="details-pane-buttons col-3 p-3 text-right">
        <slot name="menu"></slot>
        <a
          v-if="!hideClose"
          class="details-pane-close icon-remove"
          href="#"
          @click.prevent="$emit('close')"
        ></a>
      </div>
    </div>
    <div v-if="tabs.length > 0" class="details-pane-tabs row no-gutters">
      <div
        v-for="tab in tabs"
        :key="tab.key"
        class="col tab-icon ga-event"
        :class="{
          current: selectedTab == tab.key,
          'ga-event': !!tab.ga_category,
        }"
        :data-ga-category="tab.ga_category || null"
        :data-ga-action="`${tab.key}-tab`"
        :data-ga-label="tab.ga_label || null"
        :data-ga-value="tab.ga_value || null"
        @click="showTab(tab.key)"
      >
        <icon :icon="tab.icon" class="icon" />
        <span class="text">{{ tab.label }}</span>
      </div>
    </div>
    <div class="details-pane-body" :style="bodyStyle">
      <template v-if="tabs.length > 0">
        <div
          v-for="tab in tabs"
          :key="tab.key"
          v-show="tab.key == selectedTab"
          class="tab"
        >
          <slot :name="`tab-${tab.key}`"></slot>
        </div>
      </template>
      <template v-else>
        <slot></slot>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String },
    hideTitle: { type: Boolean, default: false },
    hideClose: { type: Boolean, default: false },
    tabs: { type: Array, default: () => [] },
    currentTab: { type: String },
    height: { type: Number, default: 0 },
    autoHeight: { type: Boolean, default: false },
  },
  data() {
    return {
      selectedTab: null,
      bodyHeight: null,
      minimumBodyHeight: 400,
    };
  },
  computed: {
    bodyStyle() {
      if (this.autoHeight || !this.bodyHeight) {
        return `height:auto;`;
      } else {
        var height =
          this.bodyHeight < this.minimumBodyHeight
            ? this.minimumBodyHeight
            : this.bodyHeight;
        height = `${height}px`;
        return `height:${height}; overflow:auto;`;
      }
    },
  },
  watch: {
    currentTab(val) {
      this.selectedTab = val;
    },
    height(val) {
      this.resize();
    },
  },
  methods: {
    resize() {
      // use the explicitly defined height (if provided)
      var height = this.height;
      // otherwise calculate the height based on the table list (if present)
      if (height <= 0 && $(".listable").length > 0) {
        height =
          $(".listable:first").height() -
          $(".listable:first .listable-head").height() -
          36; // the top and bottom spacing between the header row and last data row
      }
      // subtract the height of the details header
      height -= $(".details-pane-header").height();
      // subtract the height of the details tabs (if present)
      height -= $(".details-pane-tabs").height() || 0;
      // assign the height to the details body
      this.bodyHeight = height;
    },
    showTab(tab) {
      this.selectedTab = tab;
      this.$emit("show-tab", tab);
    },
  },
  mounted() {
    this.selectedTab = this.currentTab;
    this.$nextTick(() => {
      this.resize();
    });
  },
};
</script>